import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useAxiosPrivate, useUserRoles } from 'shared/hooks'
import { TransferableTargetBookingsRes } from 'features/bookings/types/bookings.types'
import { apiRoutes } from 'config/apiRoutes'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchBookings = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)
	const { isUser } = useUserRoles()

	const { data: bookingsData } = useQuery<TransferableTargetBookingsRes>({
		queryKey: queryKeys.bookings.transferableTarget(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.bookingProductTransferList(params.id as string)),
		enabled: !!auth.accessToken && isUser
	})

	return {
		bookings: bookingsData?.data
	}
}
